export default __webpack_public_path__ + "static/media/open_in_full.92d30654.svg";